import { spItemTokenGroupPageKeyFacet } from '../../../dataSource/Keys';
import { IOperationHandler } from '@ms/items-view/lib/private/store/actions/implementOperation';
import { getItemsOperation } from '@ms/items-view/lib/private/operations/getItemsOperation';
import {
  createSingleItemOperationHandler,
  ISingleOperationPayload,
  IOperationHandlerThunkAction
} from '@ms/items-view/lib/private/addons/registerOperationHandler';
import { IItemCacheDispatch } from '@ms/items-view/lib/private/store/actions/ItemCacheActions';
import { getContentTypes, constructGetItemSetContext } from '../../../dataSource/getServerDataContext';
import { getServerData } from '../../../dataSource/getServerData';
import { processResponse } from '../../../dataSource/processResponse';
import { resolveExistingPage } from '@ms/items-view/lib/private/models/items/PageHelpers';

export const spItemTokenGroupPageGetItemsOperationHandler:
  IOperationHandler<typeof spItemTokenGroupPageKeyFacet.type, typeof getItemsOperation.type> =
  createSingleItemOperationHandler({
    maxParallelOperationCount: 8
  })(getSPItemTokenGroupPage);

function getSPItemTokenGroupPage(
  payload: ISingleOperationPayload<typeof spItemTokenGroupPageKeyFacet.type, typeof getItemsOperation.type>
): IOperationHandlerThunkAction {
  const {
    itemSetKey,
    parentGroupKey,
    token
  } = spItemTokenGroupPageKeyFacet.deserialize(payload.itemKey);

  return async (dispatch: IItemCacheDispatch) => {
    const contentTypes = dispatch(getContentTypes({ itemSetKey }));
    const getItemContext = await dispatch(constructGetItemSetContext({
      itemSetKey: itemSetKey,
      contentTypes: contentTypes,
      pageToken: token,
      qosName: 'getSPItemTokenGroupPage'
    }));
    const serverData = await dispatch(getServerData(getItemContext));

    const {
      itemResolver,
      childKeys,
      groupChildKeys,
      groupLevel
    } = dispatch(processResponse({
      serverData,
      itemSetKey,
      currentPageContext: getItemContext.currentPageContext,
      contentTypes,
      parentGroupKey,
      pageItemKey: payload.itemKey,
      isItemSetRequest: true
    }));

    let childItems = childKeys;

    if (groupLevel !== undefined) {
      if (groupChildKeys[parentGroupKey]) {
        childItems = groupChildKeys[parentGroupKey] || [];
      }
    }

    // Merge items into the parent group
    itemResolver.merge(resolveExistingPage({
      itemKey: payload.itemKey,
      itemSetKey: parentGroupKey,
      childItemKeys: childItems
    }).itemResolver);

    dispatch(itemResolver.execute());
  };
}
